import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import * as U from "../../style/StyleComponentUtility";
import arrowIcon from "../../assets/icons/arrow_forward_ios.svg";
import { qnaDivision } from "../../Variable";
import theme from "../../style/theme";
import { insert_customer_qna } from "../../Axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";

const mainBlack = theme.colors.mainBlack;
const mainWhite = theme.colors.mainWhite;

const PostQna: React.FC = () => {
  const navigate = useNavigate();
  const customerData = useSelector((state:RootState) => state.customerData);
  
  const [activeDropdown, setActiveDropdown] = useState<number>(0);
  const [activeList, setActiveList] = useState<any[]>([]);
  const [division, setDivision] = useState<string>("서비스 선택");
  const [divisionID, setDivisionID] = useState<number>(0);
  const [question, setQuestion] = useState<string>("");
  const [questionLength, setQuestionLength] = useState<number>(0);

  const [qnaPhotoList, setQnaPhotoList] = useState<File[]>([]);
  const [qnaPreviewList, setQnaPreviewList] = useState<string[]>([]);

  const handleActiveDropdown = (num: number) => {
    if(activeDropdown === num) {
      return setActiveDropdown(0);
    }
    setActiveDropdown(num);
  };

  useEffect(() => {
    switch (activeDropdown) {
      case 1 : setActiveList(qnaDivision); break;
      default : setActiveList([]);
    };
  }, [activeDropdown]);

  // 사진 추가시 배열에 추가
  const insertFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if(file) {
        let list = [...qnaPhotoList];
        list.push(file);
        setQnaPhotoList(list);
    }
  };

  // 사진 삭제시 해당 index 배열에서 삭제
  const removeFile = (idx: number) => {
    let list = [...qnaPhotoList];
    list.splice(idx, 1);
    setQnaPhotoList(list);
  };

  // 배열의 값이 변할 때 마다 새로 배열 짜서 순서대로 화면에 표시
  useEffect(() => {
    let list = [];
    for (let i = 0; i < qnaPhotoList.length; i++) {
        const objectUrl = URL.createObjectURL(qnaPhotoList[i]);
        list.push(objectUrl);
    }
    setQnaPreviewList(list);
}, [qnaPhotoList]);
  
  return (
    <S.SectionContainer
      onClick={(e:React.MouseEvent<HTMLDivElement>) => {
        if(activeDropdown === 0) return;
        const target = e.target as HTMLElement;
        if(target.classList.contains('product-search-box') || target.classList.contains('product-search-input')) return;
        if(target.classList.contains('prev-construct-search-box') || target.classList.contains('prev-construct-search-input')) return;
        if(target.classList.contains('prev-construct-search-icon') || target.classList.contains('product-search-icon')) return;
        if(e.target !== e.currentTarget) {
          setActiveDropdown(0);
        }
      }}
    >
      <S.SectionWidth $width={1080}>
        <S.SectionTitleBox>
          <h1>1:1 문의 등록</h1>
          <h3>운영 시간 내에 문의해주시면 빠른 답변을 받으실 수 있습니다.</h3>
        </S.SectionTitleBox>

        <U.BreakLine $height={30} />

        <div className="flex justify-center">
          <S.PostPortfolioContainer>

            <div className="select-box">
              <S.DropdowMenuButton
                $activeButton={
                  activeDropdown === 1 ? true : false
                }
                onClick={() => {
                  handleActiveDropdown(1);
                }}
              >
                <span
                  className={`${division === "서비스 선택" && "text-gray-400"}`}
                >
                  {division}
                </span>
                <img src={arrowIcon} alt="" />
              </S.DropdowMenuButton>
              
              {activeDropdown === 1 &&
                <S.DropdownHideMenu
                  className="top-[50px]"
                  onClick={(e) => {
                    if(!(e.target instanceof HTMLElement)) return;
                    if(!e.target.classList.contains('click-target')) return;
                    const target = e.target.dataset.value;
                    setDivisionID(Number(target));
                    setDivision(qnaDivision.filter((tmp) => tmp.value === target)[0].label);
                  }}
                >
                  {activeList.map((tmp, idx) =>
                    <p
                      key={idx}
                      className="click-target"
                      data-value={tmp.value}
                    >
                      {tmp.label}
                    </p>
                  )}
                </S.DropdownHideMenu>
              }
            </div>

            <S.CommunityReviewBox className="mt-[50px]">
              <textarea
                onChange={(e) => {
                  setQuestion(e.target.value);
                  setQuestionLength(e.target.value.length);
                }}
                rows={16}
                placeholder={`문의 시 주문번호나 정보를 남겨주시면 더욱 자세한 상담이 가능합니다.`}
                maxLength={2500}
                value={question}
              />
              <div
                className="length-box"
              >
                <span>{questionLength}</span>
                <span>/ 2500</span>
              </div>
            </S.CommunityReviewBox>

            <S.PhotoBox $gridColumn={4} className="mt-2">
              {qnaPhotoList[0] ?
                  <div className="prev-item" onClick={() => removeFile(0)}>
                      <img className="prev-img" src={qnaPreviewList[0]} alt="" />
                      <div className="prev-hover">삭제</div>
                  </div>
                  :
                  <div>
                      <input
                        type="file"
                        id="ex_photo_1"
                        name='portfolio_photo_list'
                        accept=".png, .jpg, .jpeg, .webp, .gif .heif"
                        onChange={insertFile}
                      />
                      <label htmlFor="ex_photo_1">
                          <div className="photo-item">+</div>
                      </label>
                  </div>
              }
              {qnaPhotoList[1] ? 
                  <div className="prev-item" onClick={() => removeFile(1)}>
                      <img className="prev-img" src={qnaPreviewList[1]} alt="" />
                      <div className="prev-hover">삭제</div>
                  </div>
                  :
                  <div>
                      <input
                        type="file"
                        id="ex_photo_2"
                        name='portfolio_photo_list'
                        accept=".png, .jpg, .jpeg, .webp, .gif .heif"
                        onChange={insertFile}
                      />
                      <label htmlFor="ex_photo_2">
                          <div className="photo-item">+</div>
                      </label>
                  </div>
              }
              {qnaPhotoList[2] ?
                  <div className="prev-item" onClick={() => removeFile(2)}>
                      <img className="prev-img" src={qnaPreviewList[2]} alt="" />
                      <div className="prev-hover">삭제</div>
                  </div>
                  :
                  <div>
                      <input
                        type="file"
                        id="ex_photo_3"
                        name='portfolio_photo_list'
                        accept=".png, .jpg, .jpeg, .webp, .gif .heif"
                        onChange={insertFile}
                      />
                      <label htmlFor="ex_photo_3">
                          <div className="photo-item">+</div>
                      </label>
                  </div>
              }
              {qnaPhotoList[3] ?
                  <div className="prev-item" onClick={() => removeFile(3)}>
                      <img className="prev-img" src={qnaPreviewList[3]} alt="" />
                      <div className="prev-hover">삭제</div>
                  </div>
                  :
                  <div>
                      <input
                        type="file"
                        id="ex_photo_4"
                        name='portfolio_photo_list'
                        accept=".png, .jpg, .jpeg, .webp, .gif .heif"
                        onChange={insertFile}
                      />
                      <label htmlFor="ex_photo_4">
                          <div className="photo-item">+</div>
                      </label>
                  </div>
              }
          </S.PhotoBox>
            
          </S.PostPortfolioContainer>
        </div>

        <div className="flex justify-center mt-10">
          <S.EmptyRoundedButton
            $width={280}
            $btnSelect={false}
            style={{
              backgroundColor : mainBlack,
              color : mainWhite
            }}
            onClick={() => {
              if(!customerData.customer_ID) alert('계정에 문제가 있습니다. 다시 시도해 주시거나, 다시 로그인해주세요.')
              if(!window.confirm('문의를 등록하시겠습니까?')) return;
              insert_customer_qna(
                customerData.customer_ID,
                divisionID,
                question,
                qnaPhotoList
              ).then(result => {
                if(result === 1) {
                  alert('문의가 등록되었습니다.');
                  navigate('/qna');
                }
              });
            }}
          >
            등록하기
          </S.EmptyRoundedButton>
        </div>

      </S.SectionWidth>
    </S.SectionContainer>
  )
};

export default PostQna;